import * as S from './styles'
import React, {PropsWithChildren, useContext} from "react";

export enum CardVariant {
    BASE,
    PRO,
    ENTERPRISE
}

export type CardProps = {
    isActive?: boolean
    variant: CardVariant
}

export type CardItemProps = {
    isActive?: boolean
    variant?: CardVariant
}

type CardContextType = {
    isActive: boolean
    variant: CardVariant
}

export const CardContext = React.createContext<CardContextType>({variant: CardVariant.BASE, isActive: false})

const Card = ({children, variant, isActive = false}: PropsWithChildren<CardProps>) => {
    return (
        <CardContext.Provider value={{variant, isActive}}>
            <S.Card variant={variant}>
                {children}
            </S.Card>
        </CardContext.Provider>
    )
}

const CardTitle = ({children}) => {
    const { isActive, variant } = useContext(CardContext);

    return (<S.CardTitle isActive={isActive} variant={variant}>{children}</S.CardTitle>)
}

const CardContent = ({children}) => {
    const { isActive, variant } = useContext(CardContext);

    return (<S.CardContent isActive={isActive} variant={variant}>{children}</S.CardContent>)
}

const CardDescription = ({children}) => {
    const { isActive, variant } = useContext(CardContext);

    return (<S.CardDesc isActive={isActive} variant={variant}>{children}</S.CardDesc>)
}

const CardItem = ({children}) => {
    return (<S.CardItem>{children}</S.CardItem>)
}

const CardValue = ({children}) => {
    const { isActive, variant } = useContext(CardContext);

    return (<S.CardValue isActive={isActive} variant={variant}>{children}</S.CardValue>)
}

const CardText = ({children}) => {
    const { isActive, variant } = useContext(CardContext);

    return (<S.CardText isActive={isActive} variant={variant}>{children}</S.CardText>)
}

const CardFooter =  ({children}) => {
    return (<S.CardFooter>{children}</S.CardFooter>)
}

export const CardButton = ({children}) => {
    const { isActive, variant } = useContext(CardContext);

    return (<S.CardButton isActive={isActive} variant={variant}>{children}</S.CardButton>)
}

export default Object.assign(Card, {
    Title: CardTitle,
    Content: CardContent,
    Desc: CardDescription,
    Item: CardItem,
    Value: CardValue,
    Text: CardText,
    Footer: CardFooter,
    Button: CardButton
});